import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgAltIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	stroke: "currentColor",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeWidth: 2,
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M4 18h5l6-12h5M15 18h5" })
});
export default SvgAltIcon;
